<template>
  <div>
    <div class="hall-model" v-if="Bind">
      <!-- 已绑定展商 -->
      <van-popup v-model="Bind" class="bind_wrap" position="bottom" :close-on-click-overlay="false" :overlay="false" style="overflow-y: hidden;">
        <div v-if="comData || comp">
          <div class="up-btn" @click="upmove" :class="istop ? 'istopIcon' : ''">
            <i class="icon iconfont icon-shanghua"></i>
          </div>
          <div class="close-btn" @click="close">
            <i class="icon iconfont icon-guanbi2"></i>
          </div>
          <div
            class="hasBind"
            :style="{maxHeight : istop ? scollHeight + 320 + 'px' : initHeight}"
            :class="istop ? 'istop' : ''"
          >
            <div class="bind-com-top" @touchstart="upmove">
              <div class="bind-top">
                <div class="bt-logo">
                  <img :src="comp.company.logo" v-if="comp && comp.company.logo" />
                  <img v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" />
                  <img src="@/assets/img/empty.png" v-else-if="!(comp && comp.company.logo)" />
                </div>
                <div class="bt-com">
                  <p class="com-name">{{comp && comp.company.nameEn ? comp.company.nameEn  : ''}}</p>
                  <div class="rc-test-booth">
                    <span class="rc-border" v-if="comp && comp.boothInfo">
                      <i class="icon iconfont icon-dizhi"></i>
                      <span class="rc-booth">
                        {{comp.boothInfo}}
                      </span>
                    </span>
                    <span class="rc-border" v-else>
                      <i class="icon iconfont icon-dizhi" v-if="comData"></i>
                      <span>{{comData ? comData.boothCode : ''}}</span>
                    </span>
                    <span class="rc-border" v-if="comp && comp.categoryEn">
                      <i class="icon iconfont icon-biaoqian1"></i>
                      <span>{{comp.categoryEn}}</span>
                    </span>
                  </div>
                  <p class="com-icon" v-if="comp">
                    <span>
                      <i class="icon iconfont icon-huabanfuben"></i>
                      {{comp.followCount}}
                    </span>
                    <span>
                      <i class="icon iconfont icon-fenxiang"></i>
                      {{comp.shareCount}}
                    </span>
                    <span>
                      <i class="icon iconfont icon-dianzan"></i>
                      {{comp.likeCount}}
                    </span>
                    <span>
                      <i class="icon iconfont icon-zhiboguankanshu"></i>
                      {{comp.viewCount}}
                    </span>
                  </p>
                </div>
              </div>
              <div class="line" v-if="!comp"></div>
            </div>
            <div class="bind-bot" v-if="comp">
              <!-- 展位图 -->
              <div style="padding:0 15px 55px;">
                <!-- <div class="pd3-cop-intro" v-if="comp.Introduction">{{comp.Introduction ? comp.Introduction : '' }}</div> -->
                <div class="pd3-cop-intro" v-if="Introduction">
                  <p v-html="Introduction"></p>
                  <!-- {{Introduction ? Introduction : '暂无简介'}} -->
                  <span v-if="moreInt" class="pd3-more-intro" @click="moreIntroduction">More</span>
                </div>
                <!-- 展品图片 -->
                <div class="pd3-cop-act" v-if="productData && productData.length">
                  <h2 class="pd3-title">
                    Product
                    <span v-if="productTotal > 3" @click="LinkExInvitation({exhibitorId:companyId});close();">More</span>
                  </h2>
                  <div class="act-list">
                    <div
                      class="act-list-one"
                      v-for="(item,index) in productData"
                      :key="index"
                      @click="LinkProduct(item.id);close();"
                    >
                      <div class="act-one-imgbox">
                        <img
                          v-if="item.banner.search(/^\[/) !== -1"
                          :src="JSON.parse(item.banner)[0]"
                          alt
                        />
                      </div>
                      <span>{{item.nameEn || item.name}}</span>
                    </div>
                  </div>
                </div>
                <!-- 活动图片 -->
                <div class="pd3-cop-act" v-if="activityData && activityData.length">
                  <h2 class="pd3-title">
                    Active
                    <span v-if="activityTotal > 3" @click="LinkExInvitation({exhibitorId:companyId});close();">更多</span>
                  </h2>
                  <div class="act-list">
                    <div
                      class="act-list-one"
                      v-for="(item,index) in activityData"
                      :key="index"
                      @click="LinkAct(item);close();"
                    >
                      <div class="act-one-imgbox">
                        <img
                          v-if="item.banners.search(/^\[/) !== -1"
                          :src="JSON.parse(item.banners)[0]"
                          alt
                        />
                      </div>
                      <span>{{item.titleEn || item.title}}</span>
                    </div>
                  </div>
                </div>
                <!-- 参观的游客 -->
                <div class="pd3-cop-view" v-if="onlookers" style="margin-bottom:8px;">
                  <h2 class="pd3-title">
                    Viewer
                    <span>
                      {{FollowerCount}}  people(s) View
                    </span>
                  </h2>
                  <div class="pd3-cop-view-list">
                    <div class="vis_div" v-for="(item,index) in onlookers" :key="index">
                      <div class="flag-icon vis_img " :class="'flag-icon-'+item.countryCode"></div>
                      <p>{{wCount(item.viewCount)}}</p>
                      <!-- <img
                        class="img"
                        :src="item.member.avatarUrl"
                        v-if="item.member&&item.member.avatarUrl"
                      />
                      <span class="flag-icon img" v-else-if="item.member&&item.member.flagStyle" :class="'flag-icon-'+item.member.flagStyle" :key="index"></span>
                      <img class="img" src="@/assets/img/empty.png" v-else /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="noComp" v-if="!comp">
              <p>
                The booth is empty
                <span class="goLink" @click="linkToBuy(comData.boothCode)">Claim it now</span>
              </p>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="linkTab" v-if="Bind && comp">
      <div class="f_item" style="padding-right: 0.1rem;" @click="LinkExInvitation({exhibitorId:companyId});close();">
        <i class="iconfont i_zh icon-xunizhanting"></i>
        <p>Company</p>
      </div>
      <div class="f_item" v-if="!hasCollect" @click="addLove">
        <i class="iconfont i_love icon-guanzhu-xian"></i>
        <p>Follow</p>
      </div>
      <div class="f_item love" v-else @click="delLove">
        <i class="iconfont i_love icon-love icon-guanzhu-xian"></i>
        <p>UnFollow</p>
      </div>
      <!--   -->
      <div class="f_item" @click="dzClick()" v-if="!isLike">
        <i class="iconfont icon-dianzan"></i>
        <p>Like</p>
      </div>
      <div class="f_item love" @click="dzClick()" v-else>
        <i class="iconfont icon-dianzanxuanzhong"></i>
        <p>Like</p>
      </div>
      <div class="f_btn">
        <span class="van-button" @click="visitClick">APPOINT</span>
      </div>
    </div>

    <div>
    
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>

    <!-- 预约洽谈 -->
    <order ref="order"></order>

    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import gql from "graphql-tag";
import liveShare from "@/components/live-share/index";  //分享
import order from "@components/order-model.vue"; // 预约洽谈
export default {
  name: "leftNav",
  props: ["Bind", "comData"],
  data() {
    return {
      comp: null,
      productData: null,
      activityData: null,
      productTotal: 0,
      activityTotal: 0,
      companyId: null,
      banner: "",
      FollowerCount: null, // 围观数
      onlookers: "",
      lookCount: 1,
      hasCollect: false, // 是否收藏
      isLike: false, // 是否点赞
      scollHeight: 0,
      istop: false,
      Introduction: "",
      Introduction2: "",
      moreInt: false,
      moreInt2: false,
      isFirstOpen: true,
      zDisable: true, // 开展前1个月和展后一周开启
      giveExInfo: {}, //查询展商信息
      queryExhibitorUser:{},
      ipActionCountQuery:{},
      shareV:{
        content:'',
        poster:'',
      },
      isShareV:true,
    };
  },
  components: {
    liveShare,
    order
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      entranceInfo: "getCustomerInfo",
      categoryAndHallSplit: "exhibitionConfig/getcategoryAndHallSplit",
      selectBoothComId: "hall/getSelectBoothComId",
      lang: "getLang",
      userRole: "getUserRole",
    }),
    cWidth() {
      return document.body.clientWidth;
    },
    cHeight() {
      return document.body.clientHeight;
    },
    initHeight() {
      if (this.Introduction) {
        return "320px";
      } else {
        return "280px";
      }
    },
    exinfo() {
      return this.$store.getters.getEntranceInfo;
    },
    exhibitorGql() {
      return gql`
        query exhibitor($id: Guid!) {
          exhibitor(id: $id) {
            id
          }
        }
      `;
    },
  },
  watch: {
    comData(val) {
      console.log(this.comData, "选中展位的信息2");
      this.comp = null;
      this.initCom();
    },
  },
  created() {
    this.initCom();
  },
  methods: {
    ...mapActions({
      getShareConfig:'wxShare/getShareConfig', //分享
      shareToWechat:'wxShare/shareToWechat',
      addCompView:'company/addCompView',    //添加浏览记录
      addCompLove:"company/addCompLove",
      delCompLove:"company/delCompLove",
      exLike:"company/exLike",
      LinkExInvitation: "linkTo/LinkExInvitation",
      LinkAct:"linkTo/LinkAct",
      LinkProduct:'linkTo/LinkProduct',
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
      addViewLikeIp:'addViewLikeIp',
      addViewLikeIpByCountry: "addViewLikeIpByCountry",
    }),
    // 关闭公司弹框
    close() {
      this.$emit("changeBind", false);
      this.istop = false;
    },
    // 开启公司弹框
    open() {
      this.$emit("openBind", true);
      this.istop = false;
    },
    initCom() {
      this.moreInt = false;
      this.moreInt2 = false;
      this.istop = false;
      if (this.comData && this.comData.businessData[0] && this.comData.businessData[0].exhibitor) {
        this.companyId = this.comData.businessData[0].exhibitor.joinId;
        this.initData();
      } else {
        if (this.selectBoothComId && this.isFirstOpen) {
          this.companyId = this.selectBoothComId;
          this.initData();
          this.open();
          this.isFirstOpen = false;
        }
      }
    },
    visitClick(){
      if(!this.userInfo.id){
        this.$Myapollo.NoUserInfo(this)
      }
      if (this.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
      } else {
        this.$refs.order.open();
      }
    },
    //获取点赞和关注
    async getFollowAndLikeState() {
      let query = `
                 query{
                        exhibitorFollowerQuery{
                       isrFollow(exhibitorId:"${this.companyId}",userId:"${this.userInfo.userId}")
                     }
                       exhibitorLikeQuery{
                       isLike(exhibitorId:"${this.companyId}",userId:"${this.userInfo.userId}")
                    }
                }
                `;
      let opt = {
        query: query,
        variables: {},
      };

      let data = await this.graphqlPost(opt);
      // this.isFollower=this.exInfo.isFollow;
      let res = JSON.parse(JSON.stringify(data.data));

      this.hasCollect = res.exhibitorFollowerQuery.isrFollow;
      this.isLike = res.exhibitorLikeQuery.isLike;
    },
    //获取展商信息
    getInfo() {
      const query = gql`
        query exhibitor($id: Guid!) {
          giveExInfo: exhibitor(id: $id) {
            id
            compId
            boothHall
            boothInfo
            category
            categoryEn
            advisoryCount
            activityCount
            commentCount
            evaluateCount
            followCount
            likeCount
            shareCount
            lookCount
            proCount
            viewCount
            company{
                id
                introductionEn
                name
                nameEn
                summary
                shortName
                logo
                region
            }
            activities(num:3){
                id
                title
                titleEn
                banners
                acvitityType
                hasLive
                liveAuditState
            }
            products(num:3){
                id
                name
                nameEn
                banner
                shortName
            }
            exhibition{
              banners{
                covers
              }
              banner
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("giveExInfo", {
        query: query,
        variables: {
          id: this.companyId,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(res) {
            let data=JSON.parse(JSON.stringify(res.data.giveExInfo));
            if(data){
                this.comp = data;
                if (this.comp.company.introductionEn) {
                    this.comp.introductionEn = this.$service.replaceSpeace(
                    this.comp.company.introductionEn
                    );
                    let text = this.isEllipsis(this.comp.introductionEn);
                } else {
                    this.Introduction = "";
                    this.Introduction2 = "";
                }
                if(this.comp.categoryEn&&this.comp.categoryEn.indexOf('[')!==-1){
                    let cateArr=JSON.parse(this.comp.categoryEn);
                    if(cateArr[0]){
                      this.comp.categoryEn=this.getCate(cateArr);
                    } else {
                       this.comp.categoryEn= '';
                    }
                }
                if(this.comp.products){
                    this.productData = this.comp.products;
                    this.productTotal = this.comp.proCount;
                }
                if(this.comp.activities){
                    this.activityData = this.comp.activities;
                    this.activityTotal = this.comp.activityCount;
                }
                this.$store.commit("hall/setSelectBoothComId", null);
                this.setFollower();
                if (this.userInfo) {
                  this.getFollowAndLikeState();
                }
                // this.hasCollect = this.comp.isFollow;
                // this.isLike = this.comp.isLike;
            }
        },
      });
    },
    getCate(arr){
        let str='';
        for (let i = 0; i < arr.length; i++) {
          str+=str?','+arr[i].Value:arr[i].Value
        }
        return str
    },
    async initData() {
        this.getInfo();
    },
    isEllipsis(content) {
      // 计算文字长度
      let el = document.createElement("div"); // 创建一个临时div
      content = content.length > 100 ? content.substring(0, 100) : content;
      el.innerHTML = content;
      el.style.position = "absolute";
      el.style.color = "#333"; // 完全透明
      el.style.width = this.cWidth - 30 + "px";
      el.style.fontSize = "12px";
      el.style.lineHeight = "1.5";
      document.body.appendChild(el);
      const elHeight = el.clientHeight; // 获取这个含有content内容的临时div的宽度
      document.body.removeChild(el);
      if (elHeight > 42) {
        let intro = "";
        let textLength = content.length;
        for (var i = 0; i < textLength; i++) {
          el = document.createElement("div"); // 创建一个临时div
          el.innerHTML = content.substring(0, i);
          el.style.position = "absolute";
          el.style.opacity = 0; // 完全透明
          el.style.width = this.cWidth - 30 + "px";
          el.style.fontSize = "12px";
          el.style.lineHeight = "1.5";
          document.body.appendChild(el);
          let elH = el.clientHeight; // 获取这个含有content内容的临时div的宽度
          document.body.removeChild(el);
          if (elH > 42) {
            intro = content.substring(0, i);
            break;
          }
        }
        this.Introduction = intro.substring(0, intro.length - 7) + "...";
        this.Introduction2 = this.Introduction;
        this.moreInt = true;
        this.moreInt2 = true;
      } else {
        this.Introduction = content;
        this.Introduction2 = this.Introduction;
      }
    },
    moreIntroduction() {
      this.Introduction = this.comp.introductionEn;
      this.moreInt = false;
      if (!this.istop) {
        this.upmove();
      }
    },
    // 获取围观的数据
    async setFollower() {
        let userInfo = {
          nickName: this.userInfo.nickName,
          avatarUrl: this.userInfo.avatarUrl
        };
        let body = {
          compId: this.comp.compId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.companyId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo)
        };
        let res= await this.addCompView(body); // 添加围观数据
        this.getVisit(); // 获取围观人数
    },
    //获得访问信息
    getVisit(){
        let query=gql`
        query($query: _Any!) {
            ipActionCountQuery {
              page(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  id
                  country
                  countryCode
                  likeCount
                  targetType
                  viewCount
                }
              }
              sumIp(targetType: "exhibitor", targetId: "${this.companyId}") {
                userCount
                viewCount
                likeCount
              }
            }
        }`
        let where = {
          Equal: {
            n: "targetId",
            v: this.companyId,
          },
          Equal_targetType: {
            n: "targetType",
            v: 'exhibitor',
          },
          GreaterThan: {
            n: "viewCount",
            v: 0,
          },
        };
        let order = [
          {
            N: "viewCount",
            v: 0,
          },
        ];
      let opt={
          page: 1,
          size: 14,
          where: where,
          order: order,
      }
        this.$apollo.addSmartQuery("ipActionCountQuery",{
          query:query,
          variables:{
            query:opt
          },
          fetchPolicy: 'no-cache',
          result(data){
            let resData=JSON.parse(JSON.stringify(data.data.ipActionCountQuery));
            let res=resData.page;
            res.items.forEach((el)=>{
              el.countryCode=el.countryCode.toLowerCase()
            })
            // console.log(resData,'resDataresDataresDataresData')
            this.onlookers = res.items;
            this.FollowerCount = resData.sumIp?resData.sumIp.viewCount:0;
          },
          error(err){
            console.log('err',err)
          }
        })
    },

    async addLove() {
        // 展商关注
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        let userInfo={
          name:this.userInfo.name,
          avatarUrl:this.userInfo.avatarUrl,
          nickName:this.userInfo.nickName
        }
        let opt={
          compId:this.comp.compId,
          exhibitionId:this.exhibitionId,
          exhibitorId:this.companyId,
          userId:this.userInfo.userId,
          userInfo:JSON.stringify(userInfo)
        }
        let result = await this.addCompLove(opt);
        if (result.result) {
          this.hasCollect = true;
          this.$toast.success('Success');
        } else {
          this.hasCollect = false;
          this.$toast.fail(result.message);
        }
    },

    async delLove() {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        // 取消关注
        let body = {
          exhibitorId: this.companyId,
          userId: this.userInfo.userId,
        };
        let result = await this.delCompLove(body);
        if (result.result) {
          this.hasCollect = false;
          this.$toast.success('Cancel');
        } else {
          this.hasCollect = true;
          this.$toast.success(result.message);
        }
    },

    async dzClick(){
        // if (!this.userInfo) {
        //   this.$Myapollo.NoUserInfo(this);
        //   return;
        // }
       
        let body = {
          targetType: 'exhibitor',
          targetId: this.companyId,
          actionType: "like",
        };
        let res = null;
        if(this.userInfo){
            if(this.isLike){
              this.$toast("You've already liked it")
              return
            }
            let userInfo={
              name:this.userInfo.nickName||this.userInfo.name||'',
              avatarUrl:this.userInfo.avatarUrl,
              nickName:this.userInfo.nickName,
              flagStyle:this.userInfo.flagStyle || '',
            }
            let opt={
              compId:this.comp.compId,
              exhibitionId:this.exhibitionId,
              exhibitorId:this.companyId,
              userId:this.userInfo.userId,
              userInfo:JSON.stringify(userInfo)
            }
            let res1 = await this.exLike(opt);
            if(res1.result){
              this.isLike = true
              if(this.userInfo.country){
                body.country = this.userInfo.country;
                res = await this.addViewLikeIpByCountry(body);
              }
            }else{
              this.$toast.fail('fail')
            }
            return
        }else{
          res=await this.addViewLikeIp(body);
          if(res.result){
            this.$toast.success('Success');
            // this.isLike = true
          }else{
            this.$toast.fail('fail')
          }
        }
        
    },

    // 自定义分享(展商设置)
    async getShareVal(){
        let res = await this.getShareConfig(this.companyId);
        if(res&&res){
          this.shareV=JSON.parse(res);
        }
    },

    // 分享
    async share() {
        await this.getShareVal();
        let addr=this.comp.company.region;
        let bannerUrl = this.shareV.poster||this.comp.banner;
        let bannerArr=[];
        if(!bannerUrl&&this.comp.exhibition.banners.length){
          this.comp.exhibition.banners.forEach(e=>{
            bannerArr.push(e.covers)
          })
        }
        if(!bannerUrl&&!bannerArr.length){
          bannerUrl=this.comp.exhibition.banner
        }
        let opt={
          title:'给您推荐一家优质展商',
          bannerTitle:this.comp.company.name, //公司名字
          subhead:addr,
          banner:bannerUrl?[bannerUrl].slice(0,3):bannerArr.slice(0,3),
          type:"invite"
        }
        this.$nextTick(()=>{
          this.close();
          this.$refs['liveShare'].open(opt);
        })
    },

    
    upmove(e) {
      this.istop = !this.istop;
      if (this.istop) {
        // 上拉
        this.scollHeight = this.cHeight - 370;
      } else {
        // 下拉
        this.scollHeight = 0;
        this.moreInt = this.moreInt2;
        this.Introduction = this.Introduction2;
      }
    },
    LinkToTrade() {
      // 跳转至贸易对接
    //   if (!this.$store.state.isWeixin) {
    //     this.$dialog.alert({ mes: this.$t("invite.yd.wx") });
    //     return;
    //   }
    //   if (this.zDisable) {
    //     if (this.lang == "zh") {
    //       this.$router.push({
    //         path: `/hallTrade?compId=${this.companyId}&itemId=${this.$route.query.exhibitionId}`,
    //       });
    //     } else {
    //       this.$router.push({
    //         path: `/hallTrade?compId=${this.companyId}&itemId=${this.$route.query.exhibitionId}&lang=${this.lang}`,
    //       });
    //     }
    //   } else {
    //     this.$dialog.toast({ mes: "贸易对接入口已关闭" });
    //   }
    },
    linkToBuy(BoothCode) {
      this.close();
      this.$router.push(`/hallBuy/${this.exhibitionId}?booth=${BoothCode}`);
    },
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
  },
};
</script>
<style lang="scss" scoped>
// @import "../../invite/theme/invite-new2/scss/new2.scss";
.hasBind {
  // padding:15px;
  font-family: PingFang-SC-Medium;
  position: relative;
  max-height: 320px;
  // overflow-y: auto;
}
.bind_wrap{
  z-index: 100!important;
}
.bind-com-top {
  padding: 0px 15px 0;
}
.close-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 24px;
  color: #bfbfbf;
  z-index: 100;
  width: 50px;
  height: 50px;
  text-align: right;
  i {
    font-size: 24px;
  }
}
.bind-top {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  cursor: pointer;
  .bt-logo img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin-right: 15px;
    display: block;
  }
  .bt-com {
    max-width: calc(100% - 75px);
    .com-name {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      font-weight: 600;
      line-height: 26px;
      color: #333;
      min-height: 0.52rem;
    }
    .com-type {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // margin:3px 0;
    }
    .com-type span {
      font-size: 10px;
      color: #333;
      line-height: 14px;
      position: relative;
      left: -6px;
    }
    .com-type .icon-dizhi {
      color: #fe781d;
      font-size: 20px;
      margin-right: 0;
      position: relative;
      top: 3px;
      right: -2px;
    }
    .com-type .icon-biaoqian1 {
      color: #1890ff;
      position: relative;
      top: 3px;
      font-size: 20px;
    }
    .com-icon {
      display: flex;
      align-items: center;
    }
    .com-icon span {
      color: #999;
      line-height: 18px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      font-size: 12px;
    }
  }
}
.line {
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
}
.pd3-cop-hallImg {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0;
  img {
    display: block;
    width: 75px;
    height: 50px;
    background: #ccc;
    margin-right: 10px;
  }
}
.pd3-cop-intro {
  min-height: 36px;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #4d4d4d;
  text-align: justify;
  position: relative;
  p{
      font-size: 12px;
  }
}
.pd3-more-intro {
  color: #1890ff;
  position: absolute;
  right: 0;
  bottom: 0;
  // text-decoration:underline;
}
.pd3-cop-option {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 35px;
  span {
    color: #7a7a7a;
    font-size: 12px;
    display: flex;
    align-items: center;
    i {
      margin-right: 2px;
    }
    .icon-zhuanfa {
      color: #7a7a7a;
    }
  }
  em {
    color: #e5e5e5;
  }
}
.pd3-cop-img {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0;
  img {
    display: block;
    width: 75px;
    height: 50px;
    margin-right: 10px;
    background: #999;
  }
}
.pd3-cop-bot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  border-top: 1px solid #e5e5e5;
  &-l {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .bot-mob {
    font-size: 10px;
    color: #fe781d;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-right: 18px;
    .icon {
      font-size: 24px;
      color: #fe781d;
      margin-right: 5px;
      position: relative;
      top: -6px;
    }
    span {
      position: relative;
      top: -20px;
    }
  }
  .bot-zan {
    color: #808080;
    .icon {
      color: #808080;
    }
  }
  .bot-view {
    border-radius: 5px;
    border: solid 1px #fe781d;
    color: #fe781d;
    font-size: 12px;
    line-height: 28px;
    width: 70px;
    height: 30px;
    display: inline-block;
    text-align: center;
    margin-right: 5px;
  }
  .bot-love {
    color: #1890ff;
    border: solid 1px #1890ff;
  }
  .bot-love2 {
    color: #808080;
    border: solid 1px #808080;
  }
}
.noComp {
  font-size: 14px;
  color: #333;
  margin-top: 15px;
  padding: 0 15px 15px;
  p {
    text-align: center;
  }
  span {
    color: #10a2ff;
    margin-left: 20px;
  }
}

.pd3-cop-act {
  margin-top: 8px;
}
.pd3-cop-act {
  h2 {
    span {
      position: absolute;
      right: 8px;
      font-weight: 100;
      color: #666;
      font-size: 12px;
      font-style: normal;
    }
  }
}
.pd3-title {
  color: #333;
  font-size: 14px;
  line-height: 14px;
  padding: 8px 0;
  position: relative;
  left: 8px;
}
.pd3-title::before {
  content: "";
  display: block;
  width: 4px;
  height: 14px;
  background-color: #1890ff;
  position: absolute;
  left: -8px;
}
.pd3-cop-act .act-list {
  display: flex;
  align-items: center;
}
.act-list .act-list-one {
  width: 32%;
}
.act-list .act-list-one:nth-of-type(2) {
  margin: 0 2%;
}
.act-one-imgbox {
  width: 100%;
  position: relative;
  height: 76px;
  overflow: hidden;
}
.act-one-imgbox img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.act-list-one span {
  color: #333;
  font-size: 14px;
  line-height: 18px;
  margin-top: 10px;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.pd3-cop-view {
  margin-top: 8px;
  h2 {
    span {
      position: absolute;
      right: 8px;
      font-weight: 100;
      color: #666;
      font-size: 12px;
      i {
        font-style: normal;
        font-size: 14px;
      }
    }
  }
  &-list {
    display: flex;
    flex-wrap: wrap;
    margin-left:-0.2rem;
    .vis_div{
      display: flex;
      align-items: center;
      padding: 0.02rem 0 0.02rem 0.02rem;
      height: 0.46rem;
      background: #f7f7f7;
      border-radius: 90px;
      margin-left: 0.2rem;
      margin-top: 0.2rem;
      .vis_img{
        width: 0.42rem;
        height: 0.42rem;
        border-radius: 50%;
      }
      p{
        font-size: 0.22rem;
        padding: 0 0.2rem 0 0.1rem;
        color: #595757;
        line-height: inherit;
        margin-bottom: 0;
      }
    }
    // span {
    //   width: 14.285%;
    //   height: 36px;
    //   display: block;
    //   border-radius: 50%;
    //   margin-bottom: 10px;
    //   .img {
    //     width: 36px;
    //     height: 100%;
    //     display: block;
    //     border-radius: 50%;
    //     margin: auto;
    //   }
    // }
  }
  p {
    text-align: center;
    color: #1890ff;
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 20px;
  }
}
.linkTab {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  height: 55px;
  color: #fff;
  font-size: 10px;
  background: #fff;
  display: flex;
  overflow: hidden;
  align-items: center;
  padding: 0 15px;
  border-top: 1px solid #e5e5e5;
  &-l {
    display: flex;
    flex: 1;
    align-items: center;
    // margin-right: 20px;
    // justify-content: space-between
  }
  .linkTab-l-c {
    margin: 0 10%;
  }
  .linkTab-fx,
  .linkTab-zan {
    top: 1px;
  }
  .linkTab-l-item {
    // flex: 1;
    width: .72rem;
    color: #808080;
    position: relative;
    text-align: center;
    .icon {
      height: 50%;
      width: 100%;
      line-height: 50%;
      font-size: 24px;
    }
    .icon-chakanxiangqing {
      position: relative;
      font-size: 26px;
      top: 2px;
    }
    .icon-fenxiang {
      position: relative;
      top: 1px;
      font-size: 25px;
    }
    p {
      padding-top: 1;
    }
  }
  .zanAcitve {
    color: #fe781d;
  }
  &-r {
    display: flex;
    align-items: center;
    .linkTab-btn {
      width: 70px;
      height: 32px;
      line-height: 30px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      border-radius: 5px;
      border: solid 1px #fe781d;
      color: #fe781d;
    }
    .bot-love {
      color: #1890ff;
      border: solid 1px #1890ff;
      margin-right: 10px;
    }
    .bot-love2 {
      color: #808080;
      border: solid 1px #808080;
      margin-right: 10px;
    }
  }
}

.linkTab {
  .f_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    color: #808080;
    padding-top: 0.05rem;
    border-right: 1px solid #eee;
    width: 1.09rem;
    &.love {
      color: #ff5c00;
      .iconfont {
        color: transparent;
        background: linear-gradient(to right, #ffa06a, #ff5c00);
        -webkit-background-clip: text;
      }
    }
    .iconfont {
      font-size: 0.58rem;
      &.i_love {
        transform: scale(1.1);
      }
    }
    p {
      font-size: 0.2rem;
      position: relative;
      top: -0.1rem;
    }
  }
  .f_btn {
    flex-grow: 1;
    display: flex;
    padding: 0.13rem 0.24rem;
    .van-button {
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.28rem;
      width: 100%;
      color: #fff;
      text-align: center;
      display: block;
      position: relative;
      .hiddenBtn {
        width: 100%;
        height: 100%;
        display: block;
        background: black;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
      &:first-child {
        // border-radius: 0.06rem 0 0 0.06rem;
        border-radius: 0.06rem;
        background: linear-gradient(90deg, #f10100 0%, #ff4e17 100%);
      }
      &:last-child {
        border-radius: 0.06rem;
        // border-radius: 0 0.06rem 0.06rem 0;
        background: linear-gradient(
          to left,
          rgb(255, 186, 0),
          rgb(255, 166, 0)
        );
      }
      &.already {
        background: #999;
        color: #fff;
      }
    }
  }
}
.up-btn {
  text-align: center;
  height: 30px;
  transition: transform 0.25s linear;
  .icon {
    font-size: 40px;
    color: #bfbfbf;
    position: relative;
    top: -10px;
  }
}
.istop {
  overflow-y: auto;
}
.istopIcon {
  transform: rotateX(-180deg);
  transition: transform 0.25s linear;
}
.istopIcon2 {
  transform: rotateX(0deg);
}
.rc-test {
  &-booth {
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 16px;
    position: relative;
    // left:-3px;
    margin: -2px 0 2px;
    .rc-border {
      font-size: 12px;
      color: rgb(102, 102, 102);
      margin-right: 5px;
      position: relative;
      display: inline;
      padding: 1px 3px 1px 0;
    }
    .rc-booth {
      position: relative;
      margin-left: -3px;
    }
    .icon {
      font-size: 20px;
      position: relative;
      top: 3px;
      margin-left: -3px;
      display: inline-block;
    }
    .icon-dizhi {
      color: #fe781d;
    }
    .icon-biaoqian1 {
      color: #1890ff;
    }
  }
}
</style>